module.exports = __webpack_public_path__ + "img/11.a5d38671.png";